<div class="modal-header">
  <h4 class="modal-title pull-left"> Invalid Form </h4>
  <div aria-label="Close" (click)="onCancel()" class="close pull-right">
    <span aria-hidden="true">×</span></div>
</div>

<div class="modal-body">
  You have unsaved fields, please click “V” to save them or “x” to cancel.
</div>

<div class="modal-footer">
  <button class="btn btn-rbv default" (click)="onCancel()">Cancel</button>
</div>
